module.exports = __webpack_public_path__ + "static/media/NikhilBharti.d798fcd7.png";